import React from "react";

export function ScanEyeLogoPrueba({ size = "md", showText = true, className = "" }) {
  const box = size === "lg" ? "w-14 h-14" : size === "sm" ? "w-8 h-8" : "w-10 h-10";
  const text = size === "lg" ? "text-2xl" : size === "sm" ? "text-base" : "text-lg";

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className={`${box} rounded-2xl bg-black border border-[#DEFF9A]/35 shadow-[0_0_28px_rgba(222,255,154,0.18)] flex items-center justify-center overflow-hidden`}>
        <img src="/icon.svg" alt="ScanEye" className="w-full h-full object-cover" />
      </div>
      {showText && (
        <div className="leading-none">
          <div className={`font-display ${text} tracking-tight text-white`}>ScanEye</div>
          <div className="text-[9px] font-mono uppercase tracking-[0.28em] text-[#DEFF9A] mt-1">Forensic Intelligence</div>
        </div>
      )}
    </div>
  );
}
